import { dateComparator } from "utils/comparatorUtils";
import { dateRangeFilter, formatDateLocalTZ } from "utils/utils";
import { ALARMS_TABLE_STRINGS } from "constants/constantStrings";

const ALAMRS_HISTORY_TABEL_COL_DEF = [
  {
    field: "AlarmId",
    headerName: ALARMS_TABLE_STRINGS.headerAlarmID,
    flex: "1",
    editable: false
  },
  {
    field: "Description",
    headerName: ALARMS_TABLE_STRINGS.headerAlarmDesc,
    flex: "2.5",
    editable: false
  },
  {
    field: "TimeStamp",
    headerName: ALARMS_TABLE_STRINGS.headerAlarmTimestamp,
    editable: false,
    flex: "1",
    defaultSort: "desc",
    newRowsAction: "keep",
    valueFormatter: params => formatDateLocalTZ(params.data?.TimeStamp)
  }
];

export const getAlarmHistoryTableColDefs = filter =>
  ALAMRS_HISTORY_TABEL_COL_DEF.map((colDef, idx) => {
    if (idx < 2) {
      colDef = { ...colDef, filter };
    } else {
      colDef = {
        ...colDef,
        filter: "agDateColumnFilter",
        comparator: dateComparator,
        filterParams: dateRangeFilter
      };
    }
    return colDef;
  });
